import CityPageTemplate from "../city-template/CityPageTemplate";
import { florenceConfig } from "./data";

export default function FlorencePage() {
  return <CityPageTemplate config={florenceConfig} />;
}